module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/ATM-eeef98706c6df1a47038a190a2133f7a.svg";